import { Link } from "react-router-dom";

export const CGV_MSG = "Merci d'accepter les conditions générales de vente.";
export const WITHDRAWAL_MSG = "Merci de prendre connaissance des règles relatives au droit de rétractation.";

const Box = ({ id, checked, onChange, error, children }) => (
  <div>
    <label htmlFor={id} className="flex gap-3 items-start cursor-pointer">
      <input id={id} type="checkbox" checked={checked} onChange={onChange} data-testid={`input-${id}`}
        aria-invalid={error ? "true" : "false"} aria-describedby={error ? `${id}-error` : undefined}
        className="mt-1 h-6 w-6 rounded border-2 border-slate-400 accent-[#2E5683] shrink-0" />
      <span className="text-[15px] text-slate-700">{children} <span className="text-brand-ink" aria-hidden="true">*</span></span>
    </label>
    {error && <p id={`${id}-error`} role="alert" data-testid={`error-${id}`} className="mt-2 text-[15px] font-medium text-red-700">{error}</p>}
  </div>
);

export const PaymentConsents = ({ profile, setProfile, cgv, setCgv, ack, setAck, errors }) => (
  <div className="space-y-5">
    <fieldset>
      <legend className="font-semibold text-navy mb-2">Vous êtes</legend>
      <div className="grid grid-cols-2 gap-2 rounded-2xl bg-mist p-1.5">
        {[["particulier", "Particulier"], ["professionnel", "Professionnel"]].map(([v, l]) => (
          <label key={v} className={`cursor-pointer rounded-xl px-4 py-3 text-center font-semibold transition-colors ${profile === v ? "bg-navy text-white shadow" : "text-navy hover:bg-white"}`}>
            <input type="radio" name="pay-profile" value={v} checked={profile === v} onChange={() => setProfile(v)} className="sr-only" data-testid={`pay-profile-${v}`} />{l}
          </label>
        ))}
      </div>
    </fieldset>
    <Box id="cgv" checked={cgv} onChange={(e) => setCgv(e.target.checked)} error={errors.cgv}>
      J'ai lu et j'accepte les <Link to="/cgv" target="_blank" className="link-u text-navy font-semibold">conditions générales de vente</Link>, y compris les modalités de paiement en ligne.
    </Box>
    {profile === "particulier" && (
      <Box id="withdrawal_ack" checked={ack} onChange={(e) => setAck(e.target.checked)} error={errors.withdrawal_ack}>
        J'ai pris connaissance de mon droit de rétractation de 14 jours. Je demande que la prestation puisse commencer avant la fin de ce délai : en cas de rétractation, je reste redevable du montant correspondant au service déjà fourni, et je perds ce droit une fois la prestation pleinement exécutée.
      </Box>
    )}
  </div>
);

export const validateConsents = (profile, cgv, ack) => {
  const e = {};
  if (!cgv) e.cgv = CGV_MSG;
  if (profile === "particulier" && !ack) e.withdrawal_ack = WITHDRAWAL_MSG;
  return e;
};
